
export function validate_route(router, to) {
    const require_auth = to.matched.some(record => record.meta.requires_auth !== false);
    const requires_otp = to.matched.some(record => record.meta.requires_otp === true);
    const requires_organization = to.matched.some(record => record.meta.requires_organization === true);
    const requires_organization_admin = to.matched.some(record => record.meta.requires_organization_admin === true);
    const hides_from_organization_admin = to.matched.some(record => record.meta.hide_from_organization_admin === true);
    if (require_auth && !validate_auth(router)) {
        return false; // If token validation fails, do not continue to route
    }

    if (requires_otp && !validate_otp(router)) {
        return false; // If OTP verification fails, do not continue to route
    }
    if (requires_organization && !validate_organization(router)) {
        return false;
    }
    if (requires_organization_admin && !validate_organization_admin(router)) {
        return false;
    }
    if (hides_from_organization_admin && is_current_organization_admin()) {
        router.push({ name: 'OrganizationDashboard' });
        return false;
    }
    return true; // If all checks pass, continue to the route
}

export function validate_auth(router) {
    const TOKEN = sessionStorage.getItem('token');
    if (!TOKEN) {
        sessionStorage.setItem('auth_redirect_reason', 'Session expired. Please log in again.');
        router.push({ name: 'UserLogin' }); // Redirect to login page
        return false; // Token is invalid
    }
    return true; // Token is valid
}
function has_real_organization_session() {
    const ORGANIZATION = sessionStorage.getItem('current_organization');
    if (!ORGANIZATION) {
        return false;
    }

    try {
        return is_real_organization(JSON.parse(ORGANIZATION));
    } catch {
        return false;
    }
}

export function validate_otp(router) {
    const OTP_VERIFIED = sessionStorage.getItem('otp_verified');
    if (!OTP_VERIFIED) {
        sessionStorage.setItem('auth_redirect_reason', 'OTP verification is required.');
        router.push({ name: 'OneTimePin' }); // Redirect to OTP verification page
        return false; // OTP is not verified
    }
    return true; // OTP is verified
}

export function validate_organization(router) {
    if (!has_real_organization_session()) {
        router.push({ name: 'GlobalOverview' });
        return false;
    }
    return true;
}

export function validate_organization_admin(router) {
    if (!validate_organization(router)) {
        return false;
    }

    if (!is_current_organization_admin()) {
        router.push({ name: 'GlobalOverview' });
        return false;
    }

    return true;
}

export function is_current_organization_admin() {
    return sessionStorage.getItem('is_organization_admin') === 'true';
}

export function validate_token(router) {
    const TOKEN = sessionStorage.getItem('token');
    if (!TOKEN) {
        router.push({ name: 'UserLogin' });
        return false; // Token is invalid
    }
    return true; // Token is valid
}
import { is_real_organization } from '@/utils/auth/session_constants.js';
